import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';

import { MasterTab } from '../MasterTab';
import { deleteDataWithParameters, getAllDetails, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { APP_STATES, COLLEGES, UNIVERSITY, UPDATE_COLLEGES } from '../../../config/ApiConstant';
import { SkeletonbodyTemplate, Skeletonitems, defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries } from '../../../appconfig/Settings';
import { CollegeEntryColumnsList } from '../../../appconfig/DatatableSetting';
import { Dialog } from 'primereact/dialog';
import { AddCollegeEntryValidate } from '../../../config/Validate';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from 'react-router-dom';

export const CollegeEntry = () => {
    document.title = 'College Entry | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [addCollegeEntry, setAddCollegeEntry] = useState<any>({});
    const [collegeEntryList, setCollegeEntryList] = useState<any>([]);

    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [editId, setEditId] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);

    //state
    const [statesList, setStatesList] = useState<any>([]);
    //University
    const [universityList, setUniversityList] = useState<any>([]);

    // useEffect
    useEffect(() => {
        getStates();
        getAllUniversity();
        getCollegeEntryList();
    }, []);

    // Get States
    const getStates = async () => {
        try {
            const response = await getAllDetailsDirect(APP_STATES);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setStatesList([]);
                } else {
                    let stateData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const stateObj: any = {};
                        stateObj['name'] = DataList[i].name;
                        stateObj['code'] = DataList[i].id;
                        stateData.push(stateObj);
                    }
                    setStatesList(stateData);
                }
            } else {
                setStatesList([]);
            }
        } catch (error: any) {
            setStatesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get University
    const getAllUniversity = async () => {
        try {
            const response = await getAllDetailsDirect(UNIVERSITY + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setUniversityList([]);
                } else {
                    let universityData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const universityObj: any = {};
                        universityObj['name'] = DataList[i].UName;
                        universityObj['code'] = DataList[i].UName;
                        universityData.push(universityObj);
                    }
                    setUniversityList(universityData);
                }
            } else {
                setUniversityList([]);
            }
        } catch (error: any) {
            setUniversityList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'StateNm' || name === 'university') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setAddCollegeEntry({ ...addCollegeEntry, [name]: val });
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="College List" icon="pi pi-plus" className="p-button p-button-outlined mr-3" onClick={() => navigate('/app/college-entry-list')} />
                <Button label="Add College Entry" icon="pi pi-plus" className="p-button" onClick={() => openAddModal()} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-3"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Get collegeEntryList list
    const getCollegeEntryList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(COLLEGES);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setCollegeEntryList([]);
                } else {
                    setCollegeEntryList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(true);
                setCollegeEntryList([]);
            }
        } catch (error: any) {
            setPageLoad(true);
            setCollegeEntryList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Open add modal
    const openAddModal = () => {
        setAddUpdateModal(true);
    };

    // Close add modal
    const closeAddUpdateModal = () => {
        setAddCollegeEntry({});
        setEditId(null);
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
        setErrors({});
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {

        let stateObj = {
            name: rowData?.StateNm,
            code: rowData?.state
        };
        let universityObj = {
            name: rowData?.university,
            code: rowData?.university
        };

        setEditId(rowData?.orgcode);
        setAddCollegeEntry({
            collegeName: rowData?.orgnameeng,
            university: universityObj,
            StateNm: stateObj,
            collegeAddress: rowData?.Address,
            pci_code: rowData?.pci_code
        });

        setAddUpdateModal(true);
    };

    // Open delete modal
    const openDeleteModal = (index: any) => {
        setDeleteId(index);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteModal(false);
    };

    // Template for action
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="flex">
                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                    <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger p-button-rounded ml-2" onClick={() => openDeleteModal(rowData?.orgcode)} />
                </div>
            </>
        );
    };

    // On submit add update app
    const onSubmitAddUpdateApp = async () => {
        try {
            const { errors, isError } = AddCollegeEntryValidate(addCollegeEntry);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);
                //URL
                let apiUrl = COLLEGES;
                //Request object
                const requestData: any = {
                    orgnameeng: addCollegeEntry?.collegeName,
                    Address: addCollegeEntry?.collegeAddress,
                    StateNm: addCollegeEntry?.StateNm?.name,
                    state: addCollegeEntry?.StateNm?.code,
                    university: addCollegeEntry?.university?.code,
                    pci_code: addCollegeEntry?.pci_code,
                    CitySrNo: 1
                };

                if (!window.cn(editId)) {
                    requestData['orgcode'] = editId;
                    apiUrl = UPDATE_COLLEGES;
                }
                //apicall
                const response = await postAllData(apiUrl, requestData);
                if (response && !window.cn(response)) {
                    setEditId(null);
                    setAddCollegeEntry({});
                    setAddUpdateLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        setAddUpdateModal(false);
                        getCollegeEntryList();
                    }, 1000);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddUpdateLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Delete application
    const deleteApplication = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithParameters(COLLEGES + '?orgcode=' + deleteId);
            if (response) {
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.data
                });
                setTimeout(() => {
                    getCollegeEntryList();
                }, 1500);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <MasterTab mainTabLabel="College Entry" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={collegeEntryList}
                                    showGridlines
                                    stripedRows
                                    className="datatable-responsive"
                                    emptyMessage="No Data Found"
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={collegeEntryList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {CollegeEntryColumnsList.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {CollegeEntryColumnsList.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '750px' }}
                header={editId !== null ? 'Edit College Entry' : 'Add College Entry'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitAddUpdateApp()} loading={addUpdateLoader} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="collegeName">
                            College Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText value={addCollegeEntry?.collegeName} name="collegeName" autoComplete="off" placeholder="Enter College Name" onChange={(e) => onInputChange(e, 'collegeName')} className={errors['collegeName'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>

                        <small className="p-invalid-txt">{errors['collegeName']}</small>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="university">
                            University <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={addCollegeEntry?.university}
                                name="university"
                                options={universityList}
                                filter
                                optionLabel="name"
                                placeholder="Select University"
                                onChange={(e) => onInputChange(e.value, 'university')}
                                className={errors['university'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['university']}</small>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="pci_code">PCI Code</label>
                        <div className="input-effect-div">
                            <InputText value={addCollegeEntry?.pci_code} name="pci_code" autoComplete="off" placeholder="Enter PCI Code" onChange={(e) => onInputChange(e, 'pci_code')} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="StateNm">
                            State <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={addCollegeEntry?.StateNm}
                                name="StateNm"
                                options={statesList}
                                filter
                                optionLabel="name"
                                placeholder="Select State"
                                onChange={(e) => onInputChange(e.value, 'StateNm')}
                                className={errors['StateNm'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['StateNm']}</small>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="collegeCity">City</label>
                        <div className="input-effect-div">
                            <InputText value={addCollegeEntry?.collegeCity} name="collegeCity" autoComplete="off" placeholder="Enter City" onChange={(e) => onInputChange(e, 'collegeCity')} className={errors['collegeCity'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="collegeAddress">Address</label>
                        <div className="input-effect-div">
                            <InputTextarea
                                rows={4}
                                value={addCollegeEntry?.collegeAddress}
                                name="collegeAddress"
                                autoComplete="off"
                                placeholder="Enter Address"
                                onChange={(e) => onInputChange(e, 'collegeAddress')}
                                className={errors['collegeAddress'] && 'p-invalid'}
                            />
                            <span className="focus-bg"></span>
                        </div>
                        <small className="p-invalid-txt">{errors['collegeAddress']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete College Entry"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={deleteApplication} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this  College Entry, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
